export default __webpack_public_path__ + "static/media/decentraland-main-button.c14f2319.png";